import { render } from "./LegalNotice.vue?vue&type=template&id=31880d4a&ts=true"
import script from "./LegalNotice.vue?vue&type=script&lang=ts"
export * from "./LegalNotice.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__